import { useEffect } from 'react';
import { useRouter } from 'next/router';
import {
  getDefaultEmailTemplate,
  renderPlaceholdersInTemplates
} from 'shared-helpers/email';
import { useDispatch, useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import { UsersList, UsersPagination } from '.';

import type {
  GetEmailTemplatesByTypeRes,
  GetUsersByAdminRes
} from 'shared-types/responses';
import type { PageState } from 'types';

export type UpdateUserObject = {
  showLoading?: boolean;
  throwError?: boolean;
};

const Users = () => {
  const { dispatch } = useDispatch();

  const {
    language,
    serverConfig: { adminUrl },
    user
  } = useReduxState();

  const router = useRouter();

  const { loading, updateData: updateUsers } = useApiData<GetUsersByAdminRes>({
    url:
      `/admin/users-admin?includeCompletedContent=true` +
      Object.keys(router.query)
        .map((key) => (key === 'view' ? '' : `&${key}=${router.query[key]}`))
        .join(''),
    onlyIf: Boolean(user?.id),
    onDataUpdated: (data) => {
      dispatch.updatePageState({
        pages: data.pages,
        users: data.users as unknown as PageState['users'],
        usersCount: data.usersCount,
        usersAchievementData: data.achievementData,
        usersCourseData: data.courseData,
        usersPathData: data.pathData
      });
    }
  });

  useEffect(() => {
    dispatch.updatePageState({ loading });
  }, [loading]);

  const { data: emailTemplatesData } = useApiData<GetEmailTemplatesByTypeRes>({
    url: `/admin/email-templates-data?type=new-user`
  });

  let emailTemplates = emailTemplatesData?.emailTemplates || [];

  emailTemplates = renderPlaceholdersInTemplates({
    emailTemplates,
    overridePlaceholderValues: {
      contactEmail: user?.email,
      createAccountUrl: adminUrl
    }
  });

  const emailTemplatesDefault = getDefaultEmailTemplate({
    language,
    emailTemplates
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <UsersList
        emailTemplates={emailTemplates}
        emailTemplatesDefault={emailTemplatesDefault}
        updateUsers={updateUsers}
      />

      <UsersPagination />
    </div>
  );
};

export default Users;
